<template>
    <div class="info-modal banner">
      <div class="info-modal__actions">
        <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
          <a-select-option v-for="lang in langOptions" :key="lang.value">
            {{ lang.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="info-modal__content">
        <div class="info-modal__image-container">
          <img class="info-modal__image"  :src="selectedImage.path" :alt="bannerContext.name" />
        </div>
        <div class="info-modal__info-container">
          <div class="info-modal__grid">
            <div class="">
              <div class="info-modal__title">Name (for internal usage)</div>
              <span class="mr-2">{{ bannerContext.name }}</span>
              <a-tooltip title="Copy to clipboard" placement="right">
                <a href="javascript:;"><a-icon type="copy" class="font-size-16 text-primary"
                    @click="clipboardHandle('Name', bannerContext.name)" /></a>
              </a-tooltip>
            </div>
            <div>
              <div class="d-flex align-items-center">
                <div class="info-modal__title mr-2">Content type</div>
              </div>
              <div class="d-flex">
                <span v-if="bannerContext.content_type" class="mr-2">{{ bannerContext.content_type }}</span>
                <span v-else class="mr-2">-</span>
              </div>
            </div>
          </div>
          <div class="info-modal__grid">
            <div class="">
              <div>
                <div class="info-modal__title">Section</div>
                <div v-if="Array.isArray(bannerContext.displays) && bannerContext.displays.length" style="line-height: 1.8rem">
                  <a-tag class="info-modal--tag" v-for="display in bannerContext.displays" :key="display.id">
                    {{ displays[display.id] }}
                  </a-tag>
                </div>
                <div v-else>-</div>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex align-items-center">
              <div class="info-modal__title mr-2" >Schedule Periods</div>
            </div>
            <div style="position: relative; display: inline-flex; flex-direction: column; align-items: flex-start; gap: 0.2rem;">
              <template>
                <a-tag
                  v-for="(period, idx) in bannerContext.periods.slice(0, 2)"
                  :key="idx + period.starts_at"
                  class="info-modal--tag"
                >
                  {{ formatDate(period.starts_at) }} - {{ formatDate(period.ends_at) }}
                  {{ formatTimezone(period.time_mode) }}
                </a-tag>
              </template>
              <template v-if="bannerContext.periods.length > 2 && showAllPeriods">
                <a-tag
                  v-for="(period, idx) in bannerContext.periods.slice(2)"
                  :key="idx"
                  class="info-modal--tag"
                >
                  {{ formatDate(period.starts_at) }} - {{ formatDate(period.ends_at) }}
                  {{ formatTimezone(period.time_mode) }}
                </a-tag>
              </template>
              <a-button
                v-if="bannerContext.periods.length > 2"
                type="link"
                style="
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  transform: translateX(100%) translateY(-25%);
                  line-height: 1;
                  height: auto;
                  padding: 0;
                "
                @click="() => showAllPeriods = !showAllPeriods"
              >
                {{ showAllPeriods ? 'Hide' : 'View all' }}
              </a-button>
            </div>
          </div>
          <div>
            <div class="info-modal__title">Apps</div>
            <AppsCollapse :apps="bannerContext.applications"/>
          </div>
        </div>
      </div>
      <a-row>
        <a-col :span="24">
          <div class="d-flex justify-content-between info-modal__footer">
            <a-button @click="clipboardHandle('Banner', JSON.stringify(bannerContext, null, 2) )">
                <a-icon type="copy" class="font-size-14" />
                <span>Copy content</span>
              </a-button>
            <div class="ml-auto text-right">
              <a-button @click="openEditPage">
                <a-icon type="edit" class="font-size-14" />
                <span>Edit</span>
              </a-button>
              <a-button type="primary" style="margin-left: 10px;" @click="closeModal">
                OK
              </a-button>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </template>

<script>
import AppsCollapse from '@/views/apps/media/components/appsCollapse.vue'
import { routerPushWithFilters } from '@/services/utils/routerHelpers'
import { formatTimezone } from '@/services/utils/media'

export default {
  name: 'bannerInfoModal',
  components: { AppsCollapse },
  props: {
    bannerInfo: {
      type: Object,
    },
    languages: {
      type: Array,
    },
    displays: {
      type: Object,
    },
  },
  computed: {
    bannerContext() {
      return this.bannerInfo.context.context
    },
    selectedImage() {
      return this.bannerContext.images[this.selectedLanguage][0]
    },
    langOptions() {
      const langKeys = Object.keys(this.bannerContext.images)
      return this.languages.filter(language => langKeys.includes(language.name)).map(language => ({
        name: language.desc,
        value: language.name,
      }))
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    showAllPeriods: false,
  }),
  created() {
  },
  methods: {
    formatTimezone,
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
    openEditPage() {
      routerPushWithFilters(this.$router, `/media/banners/edit/${this.bannerContext.id}`)
    },
    closeModal() {
      this.$emit('close')
    },
    clipboardHandle(text, info) {
      this.$clipboard(info)
      this.$notification.success({
        message: `${text} successfully copied to clipboard`,
        description: info.slice(0, 50) + '...',
      })
    },
  },
}
</script>

<style lang="scss" src="../style.module.scss" />
